import { request } from '@max/meituan-uni-network';
import { buildCommonParams } from '../utils/common-utils';
import { reportJSInfo } from '@max/meituan-uni-report';
const isWeb = true;
import { AntiReqTool } from '@nibfe/h5guard-request';
// 统一请求处理
export const baseRequest = async (config, baseParams, params) => {
    // 构建最终参数
    const ctxCommonParams = await buildCommonParams(baseParams);
    let finalParams = {
        ...ctxCommonParams,
        ...(params || {})
    };
    // 反爬处理
    try {
        const antiReq = new AntiReqTool({
            autoFillParams: true
        });
        finalParams = antiReq.addCommonParams(finalParams);
    }
    catch (error) {
        reportJSInfo({
            level: 'info',
            content: '请求加上反爬参数错误',
            secCategory: 'ajaxError'
        }).catch();
    }
    // console.log('finalParams', finalParams);
    // 发送请求
    return new Promise((resolve, reject) => {
        request({
            url: config.url,
            data: finalParams,
            method: config.method,
            header: {
                'content-type': 'application/json'
                // 'swimlane': 'yangzezhong-rvwcx',
                // ptest: 'true',
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
                // params: {
                //   isPtest: 'true',
                // }
            },
            success(res) {
                const status = res?.data?.status;
                // console.log('res', res);
                if (status === 0) {
                    const templateRes = res?.data?.data;
                    resolve(templateRes);
                }
                else if (status) {
                    reject({
                        success: false,
                        fail: true,
                        status,
                        message: res?.data?.message
                    });
                }
                else {
                    const error = new Error('请求接口异常-未返回status业务异常');
                    error.name = 'NetworkError';
                    error.message = res?.data?.message;
                    reportJSInfo({
                        secCategory: 'ajaxError',
                        level: 'info',
                        error,
                        tags: {
                            response: JSON.stringify(res),
                            params: JSON.stringify(finalParams)
                        }
                    }).catch();
                    reject({
                        success: false,
                        fail: true,
                        code: res?.data?.code,
                        message: res?.data?.message
                    });
                }
            },
            fail(error) {
                const networkError = typeof error === 'object' ? {
                    ...error,
                    name: 'NetworkError',
                    message: '请求接口异常-网络异常'
                } : new Error('请求接口异常-网络异常');
                reportJSInfo({
                    secCategory: 'ajaxError',
                    level: 'info',
                    error: networkError,
                    tags: {
                        errorInfo: JSON.stringify(error),
                        params: JSON.stringify(finalParams)
                    }
                }).catch();
                reject({
                    ...networkError,
                    success: false,
                    fail: true
                });
            }
        });
    });
};
